import "./styles.css";
import { actions } from "../constants";
import { useEffect } from "react";
import { useWindowDimensions } from "utils/useWindowDimensions";

const Dropdown = ({
    x = 0,
    y = 0,
    show = false,
    hide,
    triggerAction,
    viewDay = true,
}) => {
    const { height, width } = useWindowDimensions();
    const positionTop = height - y < 132 ? y - 132 : y;

    const positionLeft = width - x < 159 ? x - 159 : x;

    const executeAction = (action) => () => {
        triggerAction(action);
        hide();
    };

    useEffect(() => {
        document.addEventListener("keydown", hide, false);
        return () => document.removeEventListener("keydown", hide, false);
    });

    return (
        show && (
            <div
                className="dropdown-backdrop"
                onClick={(e) => {
                    e.stopPropagation();
                    hide();
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        top: positionTop,
                        left: positionLeft,
                        zIndex: 10000,
                        borderRadius: 5,
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                    }}
                    className="shadow-lg"
                    onClick={(e) => e.stopPropagation()}
                >
                    <ul className="list-group">
                        {viewDay && (
                            <li
                                className="list-group-item text-dark px-3 py-2"
                                onClick={executeAction(actions.VIEW_DAY)}
                            >
                                <span style={{ fontSize: 12 }}>
                                    View daily events
                                </span>
                            </li>
                        )}
                        <li
                            className="list-group-item text-dark px-3 py-2"
                            onClick={executeAction(actions.NEW_EVENT)}
                        >
                            <span style={{ fontSize: 12 }}>New Event</span>
                        </li>
                    </ul>
                </div>
            </div>
        )
    );
};

export { Dropdown };
